import Messages from '@messageformat/runtime/messages'

import data from './msgData';

const messages = new Messages(data, 'en');
messages.locale = (document.documentElement.getAttribute('lang') || 'fi')
    .substring(0, 2)
    .toLowerCase();

const message = (msg, props) => messages.get(msg, props);

export default message;